export const SELF_PROMOTION_REPORT_LOADING = 'SELF_PROMOTION_REPORT_LOADING';
export const SELF_PROMOTION_REPORT_SUCCESS = 'SELF_PROMOTION_REPORT_SUCCESS';
export const SELF_PROMOTION_REPORT_ERROR = 'SELF_PROMOTION_REPORT_ERROR';
